export default __webpack_public_path__ + "static/octobox-c65d086141e78a91e11d40f064a6141e.png";